import { ALL_CALENDAR_VIEW_ID } from "../hooks/useCalendarTableViews";
import { DirectSubroutesOf } from "../routing";
import { createStore } from "./utils";

export interface CalendarStore {
  lastSelectedViewType: DirectSubroutesOf<"/calendar/view/:viewId">;
  lastSelectedViewId: string;
  selectedTimezone: string;
  selectedUserIds: string[];
  showAvailabilityOverlay: boolean;
  showArchivedBookingPages: boolean;
  setLastSelectedViewType: (viewType: DirectSubroutesOf<"/calendar/view/:viewId">) => void;
  setLastSelectedViewId: (viewId: string) => void;
  setSelectedTimezone: (timezone: string | undefined) => void;
  setSelectedUserIds: (userIds: string[]) => void;
  setShowAvailabilityOverlay: (newVal: boolean) => void;
  toggleAvailabilityOverlay: () => void;
  setShowArchivedBookingPages: (newVal: boolean) => void;
  toggleShowArchivedBookingPages: () => void;
}

export const { useStore: useCalendarStore, useShallowStore: useShallowCalendarStore } = createStore<CalendarStore>(
  (set) => ({
    lastSelectedViewType: "month",
    lastSelectedViewId: ALL_CALENDAR_VIEW_ID,
    selectedTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    selectedUserIds: [],
    showAvailabilityOverlay: false,
    showArchivedBookingPages: false,
    setLastSelectedViewType: (viewType) => {
      set({
        lastSelectedViewType: viewType,
      });
    },
    setLastSelectedViewId: (viewId) => {
      set({
        lastSelectedViewId: viewId,
      });
    },
    setSelectedTimezone: (selectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone) => {
      set({
        selectedTimezone,
      });
    },
    setSelectedUserIds: (selectedUserIds) => {
      set({
        selectedUserIds,
      });
    },
    setShowAvailabilityOverlay: (showAvailabilityOverlay) => {
      set({
        showAvailabilityOverlay,
      });
    },
    toggleAvailabilityOverlay: () => {
      set((state) => ({
        showAvailabilityOverlay: !state.showAvailabilityOverlay,
      }));
    },
    setShowArchivedBookingPages: (showArchivedBookingPages) => {
      set({
        showArchivedBookingPages,
      });
    },
    toggleShowArchivedBookingPages: () => {
      set((state) => ({
        showArchivedBookingPages: !state.showArchivedBookingPages,
      }));
    },
  }),
  {
    version: 1,
    createShallow: true,
    persist: "localStorage",
    name: "CALENDAR_STORE",
  }
);
